<template>
  <div class="price-table-wrapper">
    <div class="tit-wrap">
      <h4 class="tit-h4">{{ t('price_per_product') }}</h4>
      <span class="dim">({{ t('label_credit_per_minute') }})</span>
    </div>
    <p class="mt-1">{{ t('price_per_product_desc') }}</p>

    <div class="price-box-wrap">
      <div class="opt-price-wrap">
        <div class="box">
          <div class="head">
            <div class="flex">
              <div class="imgbox conference">
                <img :src="getAssetImageUrl('common/icons/conference-icon.svg')" alt="" />
              </div>
              <div class="tit-h5">{{ t('label_conference') }}</div>
            </div>
            <div class="ck-flex">
              <label class="app-ck-wrap">
                <input v-model="screenChecked[0]" type="checkbox" class="app-ck" />
                <span class="app-ck-icon">
                  <IconCheck />
                </span>
                <p>{{ t('screen_view') }}</p>
              </label>
              <label class="app-ck-wrap">
                <input v-model="subtitleChecked[0]" type="checkbox" class="app-ck" />
                <span class="app-ck-icon">
                  <IconCheck />
                </span>
                <p>{{ t('subtitle_view') }}</p>
              </label>
            </div>
          </div>

          <div class="box-info">
            <div class="thead">
              <p>{{ t('label_max_participants') }}</p>
              <p :class="{ on: isDefaultOn(0) }">{{ t('label_basic') }}</p>
              <p :class="{ on: screenChecked[0] && !subtitleChecked[0] }">{{ t('screen_view') }}</p>
              <p :class="{ on: subtitleChecked[0] && !screenChecked[0] }">{{ t('subtitle_view') }}</p>
              <p :class="{ on: screenChecked[0] && subtitleChecked[0] }">{{ t('label_screen_subtitle_view') }}</p>
            </div>
            <div :ref="(el) => (dlWrapRefs[0] = el)" class="dl-op-wrap">
              <dl>
                <dt>
                  <span>30</span>
                  <span>{{ t('label_person_count') }}</span>
                </dt>
                <dt>50{{ t('label_person_count') }}</dt>
                <dt>100{{ t('label_person_count') }}</dt>
                <dt>300{{ t('label_person_count') }}</dt>
                <dt>500{{ t('label_person_count') }}</dt>
                <dt>1,000{{ t('label_person_count') }}</dt>
                <dt>2,000{{ t('label_person_count') }}</dt>
                <dt>3,000{{ t('label_person_count') }}</dt>
              </dl>
              <dl class="dd-wrap" :class="{ on: isDefaultOn(0) }">
                <dd><span class="bold">160</span></dd>
                <dd><span class="bold">185</span></dd>
                <dd><span class="bold">248</span></dd>
                <dd><span class="bold">560</span></dd>
                <dd><span class="bold">748</span></dd>
                <dd><span class="bold">1,190</span></dd>
                <dd><span class="bold">1,482</span></dd>
                <dd><span class="bold">1,758</span></dd>
              </dl>
              <dl class="dd-wrap" :class="{ on: screenChecked[0] && !subtitleChecked[0] }">
                <dd><span class="bold">200</span></dd>
                <dd><span class="bold">231</span></dd>
                <dd><span class="bold">310</span></dd>
                <dd><span class="bold">700</span></dd>
                <dd><span class="bold">935</span></dd>
                <dd><span class="bold">1,488</span></dd>
                <dd><span class="bold">1,853</span></dd>
                <dd><span class="bold">2,198</span></dd>
              </dl>
              <dl class="dd-wrap" :class="{ on: subtitleChecked[0] && !screenChecked[0] }">
                <dd><span class="bold">208</span></dd>
                <dd><span class="bold">241</span></dd>
                <dd><span class="bold">322</span></dd>
                <dd><span class="bold">728</span></dd>
                <dd><span class="bold">972</span></dd>
                <dd><span class="bold">1,547</span></dd>
                <dd><span class="bold">1,927</span></dd>
                <dd><span class="bold">2,285</span></dd>
              </dl>
              <dl class="dd-wrap" :class="{ on: screenChecked[0] && subtitleChecked[0] }">
                <dd><span class="bold">248</span></dd>
                <dd><span class="bold">287</span></dd>
                <dd><span class="bold">384</span></dd>
                <dd><span class="bold">868</span></dd>
                <dd><span class="bold">1,159</span></dd>
                <dd><span class="bold">1,845</span></dd>
                <dd><span class="bold">2,298</span></dd>
                <dd><span class="bold">2,725</span></dd>
              </dl>
            </div>
            <div
              class="focus-box"
              :class="{ on: screenChecked[0] || subtitleChecked[0] }"
              :style="focusBoxStyle(0).value"
            ></div>
          </div>
        </div>

        <div class="box">
          <div class="head">
            <div class="flex">
              <div class="imgbox meeting">
                <img :src="getAssetImageUrl('common/icons/meeting-icon.svg')" alt="" />
              </div>
              <div class="tit-h5">{{ t('label_meeting') }}</div>
            </div>
            <div class="ck-flex">
              <label class="app-ck-wrap">
                <input v-model="screenChecked[1]" type="checkbox" class="app-ck" />
                <span class="app-ck-icon">
                  <IconCheck />
                </span>
                <p>{{ t('screen_view') }}</p>
              </label>
              <label class="app-ck-wrap">
                <input v-model="subtitleChecked[1]" type="checkbox" class="app-ck" />
                <span class="app-ck-icon">
                  <IconCheck />
                </span>
                <p>{{ t('subtitle_view') }}</p>
              </label>
            </div>
          </div>
          <div class="box-info">
            <div class="thead">
              <p>{{ t('label_max_participants') }}</p>
              <p :class="{ on: isDefaultOn(1) }">{{ t('label_basic') }}</p>
              <p :class="{ on: screenChecked[1] && !subtitleChecked[1] }">{{ t('screen_view') }}</p>
              <p :class="{ on: subtitleChecked[1] && !screenChecked[1] }">{{ t('subtitle_view') }}</p>
              <p :class="{ on: screenChecked[1] && subtitleChecked[1] }">{{ t('label_screen_subtitle_view') }}</p>
            </div>
            <div :ref="(el) => (dlWrapRefs[1] = el)" class="dl-op-wrap">
              <dl>
                <dt>30{{ t('label_person_count') }}</dt>
              </dl>
              <dl class="dd-wrap" :class="{ on: isDefaultOn(1) }">
                <dd><span class="bold">70</span></dd>
              </dl>
              <dl class="dd-wrap" :class="{ on: screenChecked[1] && !subtitleChecked[1] }">
                <dd><span class="bold">110</span></dd>
              </dl>
              <dl class="dd-wrap" :class="{ on: subtitleChecked[1] && !screenChecked[1] }">
                <dd><span class="bold">125</span></dd>
              </dl>
              <dl class="dd-wrap" :class="{ on: screenChecked[1] && subtitleChecked[1] }">
                <dd><span class="bold">165</span></dd>
              </dl>
            </div>
            <div
              class="focus-box"
              :class="{ on: screenChecked[1] || subtitleChecked[1] }"
              :style="focusBoxStyle(1).value"
            ></div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="head">
          <div class="imgbox audience">
            <img :src="getAssetImageUrl('common/icons/audience-icon.svg')" alt="" />
          </div>
          <div class="tit-h5">{{ t('label_audience') }}</div>
        </div>
        <div class="box-info">
          <div class="thead">
            <p>{{ t('label_max_participants') }}</p>
            <p>{{ t('label_basic') }}</p>
          </div>
          <div class="dl-wrap">
            <dl>
              <dt>-</dt>
              <dd><span class="bold">27</span></dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="head">
          <div class="imgbox general">
            <img :src="getAssetImageUrl('common/icons/general-icon.svg')" alt="" />
          </div>
          <div class="tit-h5">{{ t('label_general') }}</div>
        </div>
        <div class="box-info">
          <div class="thead">
            <p>{{ t('label_max_participants') }}</p>
            <p>{{ t('label_basic') }}</p>
          </div>
          <div class="dl-wrap">
            <dl>
              <dt>2{{ t('label_person_count') }}</dt>
              <dd><span class="bold">31</span></dd>
            </dl>
            <dl>
              <dt>10{{ t('label_person_count') }}</dt>
              <dd><span class="bold">79</span></dd>
            </dl>
            <dl>
              <dt>30{{ t('label_person_count') }}</dt>
              <dd><span class="bold">118</span></dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="head">
          <div class="imgbox single">
            <img :src="getAssetImageUrl('common/icons/single-icon.svg')" alt="" />
          </div>
          <div class="tit-h5">{{ t('label_single') }}</div>
        </div>
        <div class="box-info">
          <div class="thead">
            <p>{{ t('label_max_participants') }}</p>
            <p>{{ t('label_basic') }}</p>
          </div>
          <div class="dl-wrap">
            <dl>
              <dt>-</dt>
              <dd><span class="bold">27</span></dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue';

import IconCheck from '@/components/icons/IconCheck.vue';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

// ✅ 각각의 체크박스 상태
const screenChecked = ref([false, false]);
const subtitleChecked = ref([false, false]);

// ✅ ref도 배열로
const dlWrapRefs = ref([null, null]);
const focusLefts = ref([0, 0]);
const focusWidths = ref([0, 0]);

// 모바일 여부 감지
const isMobile = ref(window.innerWidth <= 768);
const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

const targetDlIndex = (i: number) => {
  if (screenChecked.value[i] && subtitleChecked.value[i]) return 4;
  if (screenChecked.value[i]) return 2;
  if (subtitleChecked.value[i]) return 3;
  return 1;
};

const updateFocusPosition = (i: number) => {
  if (!dlWrapRefs.value[i]) return;

  const index = targetDlIndex(i);
  const dlList = dlWrapRefs.value[i].querySelectorAll(':scope > dl');
  const targetDl = dlList[index];

  if (!targetDl) return;

  const dlWidth = targetDl.offsetWidth;
  const focusWidth = dlWidth - 10;

  focusWidths.value[i] = focusWidth;
  // ✅ 오른쪽 끝 기준: dl의 오른쪽 끝 - focusWidth
  focusLefts.value[i] = targetDl.offsetLeft + dlWidth - focusWidth;
};

watch(
  [screenChecked, subtitleChecked],
  () => {
    nextTick(() => {
      updateFocusPosition(0);
      updateFocusPosition(1);
    });
  },
  { deep: true }
);

let resizeObservers: (ResizeObserver | null)[] = [null, null];

onMounted(() => {
  window.addEventListener('resize', handleResize);
  [0, 1].forEach((i) => {
    updateFocusPosition(i);

    resizeObservers[i] = new ResizeObserver(() => updateFocusPosition(i));

    if (dlWrapRefs.value[i]) {
      resizeObservers[i]!.observe(dlWrapRefs.value[i]);
    }
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  resizeObservers.forEach((o) => o?.disconnect());
});

const focusBoxStyle = (i: number) =>
  computed(() => ({
    position: 'absolute',
    left: focusLefts.value[i] + 'px',
    width: focusWidths.value[i] + 'px',
  }));

// 모바일 + 미체크 시 기본 on 여부
const isDefaultOn = (i: number) => {
  return isMobile.value && !screenChecked.value[i] && !subtitleChecked.value[i];
};
</script>
<style scoped lang="scss">
input[type='checkbox'] {
  display: none;
}

.price-table-wrapper {
  padding: 168px 0 120px;
  .tit-wrap {
    .tit-h4 {
      display: inline-block;
    }
    span {
      position: relative;
      padding-left: $spacing2;
      vertical-align: $spacing1;
    }
  }
  .price-box-wrap {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    margin-top: 1.5rem;
    flex-wrap: wrap;
    .opt-price-wrap {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      .box {
        flex: 1;
        min-width: 730px;
        position: relative;
        .head {
          justify-content: space-between;
          align-items: flex-end;
          .flex {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
          .ck-flex {
            display: flex;
            flex-wrap: wrap;
            column-gap: $spacing4;
            row-gap: $spacing1;
          }
        }
        .box-info {
          position: relative;
          .focus-box {
            background: $color-navy-100;
            height: calc(100% + 10px);
            position: absolute;
            top: 0;
            opacity: 0;
            transition: left 0.3s ease-in-out;
            border-radius: 0.5rem;
            box-shadow: 0 0 10px rgba(71, 95, 216, 0.3);
            &.on {
              opacity: 1;
            }
          }
          .thead {
            padding: 0.375rem 0;
            p {
              min-width: 100px;
              text-align: right;
              z-index: 1;
              flex: 1;
              padding: 0 1.25rem;
              word-break: break-word;
              &:first-child {
                text-align: left;
              }
              &.on {
                transition-delay: 0.2s;
                color: #fff;
              }
            }
          }
          .focus-info {
            position: absolute;
          }
          .dl-op-wrap {
            display: flex;
            justify-content: space-between;
            padding: 0.25rem 0 0;
            dl {
              min-width: 100px;
              flex: 1;
              z-index: 1;
            }
            .dd-wrap {
              text-align: right;
              dd {
                width: 100%;
                justify-content: flex-end;
                font-size: $font-size-psmall;
                line-height: 24px;
                letter-spacing: -0.5px;
                padding: 0.25rem 1.25rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
                span {
                  font-size: $font-size-p;
                }
              }
              &.on {
                dd {
                  transition-delay: 0.2s;
                  color: #fff;
                  span {
                    transition-delay: 0.2s;
                    color: #fff;
                  }
                }
              }
            }
          }
          dt {
            padding: 0.25rem 0 0.25rem 1.25rem;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: initial;
            display: block;
          }
        }
      }
    }
    .box {
      flex: 1 1 0%;
      border: 1px solid $color-gray-40;
      border-radius: $size-m;
      padding: 1.25rem;
      min-width: 280px;
      .head {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: $size-s;
        margin-bottom: 1.25rem;

        .imgbox {
          width: 48px;
          height: 48px;
          border-radius: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          &.conference {
            background: $conference-bg;
          }
          &.meeting {
            background: $meeting-bg;
          }
          &.audience {
            background: $audience-bg;
          }
          &.general {
            background: $general-bg;
          }
          &.single {
            background: $single-bg;
          }
          img {
            width: 28px;
            height: 28px;
            object-fit: contain;
          }
        }
      }
      .box-info {
        .thead {
          background: $color-gray-10;
          padding: 0.375rem 1.25rem;
          min-height: 2.5rem;
          border-radius: $size-s;
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
            font-size: $font-size-psmall;
            color: $color-gray-600;
            font-weight: $font-weight-medium;
            line-height: 120%;
          }
          &:nth-child(2) {
            text-align: right;
          }
        }
        .dl-wrap {
          padding: 0.75rem 1.25rem;
          dl {
            display: flex;
            justify-content: space-between;
            padding-bottom: $size-m;
            &:last-child {
              padding-bottom: 0;
            }
            dd {
              font-size: $font-size-psmall;
              gap: 0.25rem;
              .bold {
                font-size: $font-size-p;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
}

.app-ck-wrap {
  p {
    font-size: $font-size-psmall;
  }
}

@media (max-width: 1500px) {
  .price-table-wrapper {
    .price-box-wrap {
      .box {
        padding: 1rem;
      }
    }
  }
}

@include respond-to(tablet) {
  .price-table-wrapper {
    padding: 120px 0 80px;
    .price-box-wrap {
      flex-direction: column;
      gap: 0.75rem;
      .opt-price-wrap {
        .box {
          min-width: auto;
          width: 100%;
          flex: auto;
          .box-info {
            dt {
              padding: 0.25rem 0 0.25rem 0.75rem;
            }
          }
        }
      }
    }
  }
}

@include respond-to(mobile-landscape) {
  .opt-price-wrap {
    .focus-box {
      display: none;
    }
    .box {
      .box-info {
        .thead {
          p {
            display: none;
            padding: 0 0.75rem !important;
            &:first-child {
              display: block;
            }
            &.on {
              display: block;
              color: $color-gray-900 !important;
            }
          }
        }
      }
    }
    .dl-op-wrap {
      .dd-wrap {
        display: none;
        flex: initial;
        &.on {
          display: block;
          dd {
            padding: 0.25rem 0.75rem !important;
          }
          dd,
          span {
            color: $color-gray-900 !important;
          }
          dt {
            padding: 0.25rem 0 0.25rem 0.75rem;
          }
        }
      }
    }
  }
  .price-table-wrapper {
    .price-box-wrap {
      .box {
        .box-info {
          .thead {
            padding: 0 0.75rem;
          }
          .dl-wrap {
            padding: 0.75rem;
          }
        }
      }
    }
  }
}

@include respond-to(mobile-portrait) {
  .price-table-wrapper {
    .price-box-wrap {
      .opt-price-wrap {
        .box {
          .head {
            flex-direction: column;
            align-items: flex-start;
            .ck-flex {
              padding-left: $spacing1;
            }
          }
        }
      }
    }
  }
}
</style>
